<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="设备信息" name="first">
          <deviceForm :row="row"></deviceForm>
        </el-tab-pane>
        <el-tab-pane label="使用人信息" name="second">
          <userForm :row="row"></userForm>
         </el-tab-pane>
        <el-tab-pane label="维修记录" name="third">
          <repairForm ref="repairFormref" :row="row"></repairForm>
        </el-tab-pane>
        
        <el-tab-pane label="保养记录" name="fourth">
          <maintenanceRecord  ref="maintenanceRecordref" :row="row"></maintenanceRecord>
        </el-tab-pane>
        <el-tab-pane
          label="报废记录"
          name="five"
        >
        <scrapForm ref="scrapFormref" :row="row"></scrapForm>
        </el-tab-pane>

       
      </el-tabs>
      
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import deviceForm from './components/deviceForm.vue';
import userForm from './components/userForm.vue';
import repairForm from './components/repairRecord.vue';
import maintenanceRecord from './components/maintenanceRecord.vue';
import scrapForm from './components/scrapForm.vue';
import { removeStore, getStore } from '@/util/store';
import { setStore } from '@/util/store';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
} from '../api/serveItemManage';
export default {
  components: {deviceForm,userForm,repairForm,maintenanceRecord,scrapForm},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    nursinghomeName: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      activeFlag: true,
      projectList: [],
      activeName: 'first',
      form: {
        nursinghomeId: '',
        name: '',
        // birthday: '123',
        idNumber: '',
      },
      formRules: {
        // idNumber: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        // consumableName: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        // nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        // consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
   
    successHandler() {
      this.$emit('stepsuccess');
    },
    initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      if (this.model == 'add') {
        this.form.nursinghomeId = this.nursinghomeId;
        this.form.nursinghomeName = this.nursinghomeName;
        //  getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;

        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
      } else {
        this.form = this._.cloneDeep(this.row);
        let self = this;
        console.log(self.form, 'self.form============>');
        console.log(self.form.elderlyId, 'self.form.elderlyId============>');
        this.form.nursinghomeName = this.nursinghomeName;
        setStore({
          name: 'elderId',
          content: self.form.id,
        });
      }
    },
   
    tabsBefore() {
      console.log(this.activeName);
      console.log(getStore({ name: 'elderId' }));

      // this.activeFlag = this.$refs.baseInfoRef.saveRecord()
      if (getStore({ name: 'elderId' }) && getStore({ name: 'elderId' }) + '' !== 'undefined') {
        return true;
      } else {
        return false;
      }
      if (this.activeFlag) {
        return true;
      } else {
        return false;
      }
    },
    handleClick() {
      if (this.activeName === 'first') {
       
      }
      if (this.activeName === 'second') {
      
      }
      if (this.activeName === 'third') {
      
        // this.activeName = 'fourth'
      }
      if (this.activeName === 'fourth') {
       
        // this.activeName = 'five'
      }
      if (this.activeName === 'five') {
      
      }
      this.$refs.repairFormref.refleshTable()
      this.$refs.maintenanceRecordref.refleshTable()
     
      console.log(this.activeName);
    },
    cancleRecord() {
      removeStore({
        name: 'elderId',
      });
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
